import { useState, useEffect } from "react";

export default function AdminDashboard() {
  const [companies, setCompanies] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [company_name, setCompanyName] = useState("");
  const [subdomain, setSubdomain] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  //save user Data
  const [user, setUser] = useState<any[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [deleteCompanyId, setDeleteCompanyId] = useState<number | null>(null);

  const loadAllCompanies = async () => {
    const companies = await fetch(`${process.env.REACT_APP_API_URL}/companies`);
    const data = await companies.json();
    console.log(data);
    //da das Backend mit succes: true, companies: ... antwortet müssen wir hier .companies schreiben
    setCompanies(data.companies ?? []);
  };

  const handleCompanyregistration = async () => {
    const companyRegistration = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/register`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ company_name, subdomain, email, password }),
      },
    );
    const data = await companyRegistration.json();
    console.log(data.company);
    console.log(data.user);
    setShowModal(false);
    loadAllCompanies();
  };
  const loadUser = async (company_id: number) => {
    const user = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/${company_id}/users`,
    );
    const data = await user.json();
    console.log(data);
    //users weil backend nach message und so users: ... zurrückschickt
    setUser(data.users);
  };
  const handleDelete = async (company_id: number) => {
    const result = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/delete`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ companie_id: company_id }),
      },
    );
    const data = await result.json();
    if (data) {
      setSelectedCompany(null);
      loadAllCompanies();
    }
    console.log(data);
  };
  /*
  const handleDeletePop = async (company_id: number) => {
    if (!window.confirm("Firma wirklich löschen?")) return;
    // rest des codes
  };
  */
  useEffect(() => {
    loadAllCompanies();
  }, []);
  return (
    <>
      <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
            .dashboard-wrap {
              min-height: 100vh;
              background: #0a0a0f;
              font-family: 'DM Sans', sans-serif;
              color: #f0f0f0;
              padding: 48px;
            }
            .dashboard-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 48px;
            }
            .dashboard-title {
              font-family: 'Syne', sans-serif;
              font-size: 2rem;
              font-weight: 800;
              letter-spacing: -0.03em;
            }
            .dashboard-title span { color: #c8f135; }
            .dashboard-badge {
              display: inline-flex;
              align-items: center;
              gap: 8px;
              background: rgba(200,241,53,0.1);
              border: 1px solid rgba(200,241,53,0.2);
              color: #c8f135;
              padding: 5px 14px;
              border-radius: 100px;
              font-size: 0.7rem;
              font-weight: 700;
              letter-spacing: 0.08em;
              text-transform: uppercase;
            }
            .companies-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                gap: 20px;
                margin-bottom: 32px;
                padding-right: 440px; /* 400px modal + 40px Puffer */
            }
          .company-card {
            background: #14141e;
            border: 1px solid rgba(255,255,255,0.07);
            border-radius: 16px;
            padding: 24px;
            transition: border-color 0.2s, transform 0.2s;
            cursor: pointer;
          }
          .company-card:hover { 
            border-color: rgba(200,241,53,0.4);
            transform: translateY(-2px);
          } 
            .company-name {
              font-family: 'Syne', sans-serif;
              font-size: 1rem;
              font-weight: 700;
              margin-bottom: 8px;
            }
            .btn-add {
              background: #c8f135;
              color: #0a0a0f;
              border: none;
              border-radius: 10px;
              padding: 12px 28px;
              font-family: 'DM Sans', sans-serif;
              font-size: 0.9rem;
              font-weight: 700;
              cursor: pointer;
              transition: opacity 0.2s;
            }
            .btn-add:hover { opacity: 0.88; }
              .modal-form-group {
            margin-bottom: 16px;
          }
          .modal-form-group label {
            display: block;
            font-size: 0.75rem;
            font-weight: 600;
            color: #6b6b7a;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            margin-bottom: 8px;
          }
          .modal-form-group input {
            width: 100%;
            background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.07);
            border-radius: 10px;
            padding: 12px 16px;
            color: #f0f0f0;
            font-family: 'DM Sans', sans-serif;
            font-size: 0.9rem;
            outline: none;
            transition: border-color 0.2s;
          }
          .modal-form-group input:focus {
            border-color: rgba(200,241,53,0.4);
          }
          .modal-form-group input::placeholder { color: #3a3a4a; }
        .infoText {
          color: #6b6b7a;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 4px;
        }
          `}</style>

      <div className="dashboard-wrap">
        <div className="dashboard-header">
          <div className="dashboard-title">
            Admin<span>.</span>
          </div>
          <div className="dashboard-badge">Admin Panel</div>
        </div>

        <div className="companies-grid">
          {companies.length === 0 ? (
            <p style={{ color: "rgba(255,255,255,0.4)" }}>
              Keine Firma Regestriert
            </p>
          ) : (
            companies.map((company) => (
              <div
                onClick={() => {
                  setSelectedCompany(company);
                  loadUser(company.id);
                }}
                key={company.id}
                className="company-card"
              >
                <div className="company-name">{company.name}</div>
              </div>
            ))
          )}
        </div>

        <button className="btn-add" onClick={() => setShowModal(true)}>
          Firma Registrieren
        </button>
        {showModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "#14141e",
                border: "1px solid rgba(255,255,255,0.07)",
                padding: "100px",
                borderRadius: "20px",
                width: "420px",
              }}
            >
              <h2
                style={{
                  fontFamily: "Syne, sans-serif",
                  fontSize: "1.5rem",
                  fontWeight: 800,
                  marginBottom: "24px",
                }}
              >
                Firma Registrieren
              </h2>

              <div className="modal-form-group">
                <label>Firmenname</label>
                <input
                  type="text"
                  placeholder="Mueller GmbH"
                  value={company_name}
                  // onChange wird benötigt da der Browser bei jeder Eingabe ein Event-Objekt mitschickt.
                  // e.target.value enthält den aktuellen Wert des Input-Feldes.
                  // Die Arrow-Funktion "entpackt" das Event und gibt nur den Wert an setCompanyName weiter.
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              <div className="modal-form-group">
                <label>Subdomain</label>
                <input
                  type="text"
                  placeholder="mueller-gmbh"
                  value={subdomain}
                  onChange={(e) => setSubdomain(e.target.value)}
                />
              </div>

              <div className="modal-form-group">
                <label>HR-User Email</label>
                <input
                  type="email"
                  placeholder="hr@mueller.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="modal-form-group">
                <label>HR-User Passwort</label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
                {/*Handle registrirung von firma*/}
                <button
                  onClick={handleCompanyregistration}
                  className="btn-add"
                  style={{ flex: 1 }}
                >
                  Registrieren
                </button>
                <button
                  onClick={() => setShowModal(false)}
                  style={{
                    flex: 1,
                    background: "transparent",
                    border: "1px solid rgba(255,255,255,0.07)",
                    color: "#f0f0f0",
                    borderRadius: "10px",
                    padding: "12px",
                    cursor: "pointer",
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                  }}
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        )}
        {showDeleteModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 200,
            }}
          >
            <div
              style={{
                background: "#14141e",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "16px",
                padding: "32px",
                width: "360px",
              }}
            >
              <h3 style={{ margin: "0 0 8px 0" }}>Firma löschen</h3>
              <p
                style={{ color: "rgba(255,255,255,0.4)", margin: "0 0 24px 0" }}
              >
                Bist du sicher? Diese Aktion kann nicht rückgängig gemacht
                werden.
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                }}
              >
                <button onClick={() => setShowDeleteModal(false)}>
                  Abbrechen
                </button>
                <button
                  onClick={() => {
                    handleDelete(selectedCompany.id);

                    setShowDeleteModal(false);
                  }}
                >
                  Löschen
                </button>
              </div>
            </div>
          </div>
        )}
        {selectedCompany && (
          <div
            style={{
              position: "fixed",
              right: 0,
              top: 0,
              bottom: 0,
              width: "400px",
              background: "#14141e",
              borderLeft: "1px solid rgba(255,255,255,0.07)",
              padding: "40px",
              zIndex: 100,
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setSelectedCompany(null)}
              style={{ alignSelf: "flex-end", marginBottom: "16px" }}
            >
              ✕
            </button>

            <p className={"infoText"}>Firmenname</p>
            <h2 style={{ margin: 0 }}>{selectedCompany.name}</h2>

            <p className={"infoText"} style={{ marginTop: "16px" }}>
              Subdomain
            </p>
            <p style={{ margin: 0 }}>{selectedCompany.subdomain}</p>

            <p className={"infoText"} style={{ marginTop: "16px" }}>
              Erstellt am
            </p>
            <p style={{ margin: 0 }}>{selectedCompany.created_at}</p>

            <p className={"infoText"} style={{ marginTop: "24px" }}>
              Benutzer
            </p>
            {user.length === 0 ? (
              <p style={{ color: "rgba(255,255,255,0.4)" }}>
                Keine Benutzer vorhanden
              </p>
            ) : (
              user.map((users) => (
                <div
                  key={users.id}
                  style={{
                    background: "rgba(255,255,255,0.05)",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <p style={{ margin: 0, fontWeight: "bold" }}>{users.email}</p>
                  <p
                    style={{
                      margin: 0,
                      color: "rgba(255,255,255,0.4)",
                      fontSize: "12px",
                    }}
                  >
                    ID: {users.id}
                  </p>
                </div>
              ))
            )}
            <button
              onClick={() => {
                // setDeleteCompanyId(selectedCompany.id);
                setShowDeleteModal(true);
              }}
              style={{ position: "absolute", bottom: "40px", right: "40px" }}
            >
              Löschen
            </button>
          </div>
        )}
      </div>
    </>
  );
}
